import type { SagaIterator } from 'redux-saga';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import type { UUID } from '@appcues/domain-types';
import { INITIALIZE } from 'ext/root/root-actions';
import { getTypedContext } from 'ext/lib/saga-context';
import { completeInteraction, FETCH_ACCOUNTS } from 'ext/lib/track';
import { selectUserId } from 'ext/entities/account';
import type { UserAccountsResponse } from 'ext/lib/api/types';
import { resolve, reject } from './actions';

export function* fetchUserAccounts(): SagaIterator {
  try {
    const api = yield* getTypedContext('api');
    const userId: UUID | undefined = yield select(selectUserId);
    if (!userId) {
      throw new Error('User ID is required to fetch user accounts');
    }
    const response: UserAccountsResponse = yield call(
      api.getUserAccounts,
      userId
    );
    yield put(resolve(response.accounts));
    yield put(completeInteraction(FETCH_ACCOUNTS));
  } catch (error) {
    yield put(reject(error as Error));
  }
}

export default function* accountsSaga(): SagaIterator {
  yield takeEvery(INITIALIZE, fetchUserAccounts);
}
